import { render, staticRenderFns } from "./OverviewView.vue?vue&type=template&id=505dafa7&scoped=true"
import script from "./OverviewView.vue?vue&type=script&lang=js"
export * from "./OverviewView.vue?vue&type=script&lang=js"
import style0 from "./OverviewView.vue?vue&type=style&index=0&id=505dafa7&prod&scoped=true&lang=css"
import style1 from "./OverviewView.vue?vue&type=style&index=1&id=505dafa7&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "505dafa7",
  null
  
)

export default component.exports